// Required to ensure URLs GET requests match the API keys being used.
var hostpath = "http://www.cheltenhambranch.org.uk";

// Convert a 6 figure OS Grid Reference to (x,y) coordinates
function osgrid_coord_conv(gr) {
   var digraph = {
    // NOTE y,x
    "SV" : [0,0],
    "SW" : [0,1],
    "SX" : [0,2],
    "SY" : [0,3],
    "SZ" : [0,4],
    "TV" : [0,5],

    "SR" : [1,1],
    "SS" : [1,2],
    "ST" : [1,3],
    "SU" : [1,4],
    "SQ" : [1,5],
    "TR" : [1,6],
  
    "SM" : [2,1],
    "SN" : [2,2],
    "SO" : [2,3],
    "SP" : [2,4],
    "TL" : [2,5],
    "TM" : [2,6],

    "SH" : [3,2],
    "SJ" : [3,3],
    "SK" : [3,4],
    "TF" : [3,5],
    "TG" : [3,6],

    "SC" : [4,2],
    "SD" : [4,3],
    "SE" : [4,4],
    "TA" : [4,5],
  
    "NW" : [5,1],
    "NX" : [5,2],
    "NY" : [5,3],
    "NZ" : [5,4],
    "OV" : [5,5],

    "NR" : [6,1],
    "NS" : [6,2],
    "NT" : [6,3],
    "NU" : [6,4],
  
    "NL" : [7,0],
    "NM" : [7,1],
    "NN" : [7,2],
    "NO" : [7,3],
  
    "NF" : [8,0],
    "NG" : [8,1],
    "NH" : [8,2],
    "NJ" : [8,3],
    "NK" : [8,4],
  
    "NA" : [9,0],
    "NB" : [9,1],
    "NC" : [9,2],
    "ND" : [9,3],

    "HW" : [10,1],
    "HX" : [10,2],
    "HY" : [10,3],
    "HZ" : [10,4],

    "HT" : [11,3],
    "HU" : [11,4],

    "HP" : [12,4]
  };

  var matches = gr.match(/^([a-zA-Z]{2})([0-9]{3})([0-9]{3})$/);
  if (matches) {
    var lu = digraph[matches[1]];
    return [lu[1] + matches[2] + "00", lu[0] + matches[3] + "50"];
  } else {
    return ["0", "0"];
  }
}

// 1) If $str is supplied, pass it in to the URL to be used in the info pop-up box
//    attached to the marker.
// 2) Single quote characters seem to mess up the javascript call even if they are
//    urlencoded, so they need to be manually escaped.
// 3) If shortamp is true, use '&' separators, otherwise default to using '&amp;'.
// 4) str & shortamp are optional parameters.
function map_xy_url(x, y, str, shortamp) {
  var amp;
  if (shortamp) {
    amp = '&';
  } else {
    amp = '&amp;';
  }
  var ret = hostpath + '/os_map.php?x=' + x + amp + 'y=' + y;
  if(str) {
    if (shortamp) {
      return ret + amp + 's=' + encodeURIComponent(str);
    } else {
      return ret + amp + 's=' + encodeURIComponent(str.replace("'", "\'"));
    }
  } else {
    return ret;
  }
}

// 1) If $str is supplied, pass it in to the URL to be used in the info pop-up box
//    attached to the marker.
// 2) Single quote characters seem to mess up the javascript call even if they are
//    urlencoded, so they need to be manually escaped.
// 3) If shortamp is true, use '&' separators, otherwise default to using '&amp;'.
// 4) str & shortamp are optional parameters.
function map_grid_url(gr, str, shortamp) {
  var pair = osgrid_coord_conv(gr);
  return map_xy_url(pair[0], pair[1], str, shortamp);
}
